const PREFIX = 'PROMO_BANNER_',
SET = 'SET_';

/**
 * @name SET_PROMO_BANNER
 * @const
 * @description Stores the promotionm banner Info
 */
export const SET_PROMO_BANNER = PREFIX + SET + 'DATA';


